import {
  CalendarRef,
  DefaultCalendarWrite,
  ExternalConnection,
} from '@griply/types';
import { useCallback } from 'react';

export type BuildDefaultCalendarWrites = (
  connections: ExternalConnection[],
  next: CalendarRef,
) => DefaultCalendarWrite[];

export type UseSetDefaultCalendarOptions = {
  connections: ExternalConnection[];
  // Injected: the write-payload builder lives in @griply/services, which this package may not import.
  buildWrites: BuildDefaultCalendarWrites;
  mutate: (write: {
    id: DefaultCalendarWrite['connectionId'];
    settings: { defaultCalendar: DefaultCalendarWrite['defaultCalendar'] };
  }) => void;
};

export const useSetDefaultCalendar = ({
  connections,
  buildWrites,
  mutate,
}: UseSetDefaultCalendarOptions) =>
  useCallback(
    (next: CalendarRef) =>
      buildWrites(connections, next).forEach(
        ({ connectionId, defaultCalendar }) =>
          mutate({ id: connectionId, settings: { defaultCalendar } }),
      ),
    [buildWrites, connections, mutate],
  );
